var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100%"},attrs:{"id":"app"}},[_c('v-app',{staticClass:"cppsbg",attrs:{"id":"ukpl"}},[_c('router-view'),_c('EmailVerificationDialog')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }